import React, { useEffect, useState } from 'react';
import './MealUpgradeDecisionModal.css';

const MealUpgradeDecisionModal = ({ extraFoods = [], onChoose, onSettled, close, modalService }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => modalService?.onBeforeClose?.(() => {
    if (isSubmitting) return false;
    onSettled?.();
    return true;
  }), [isSubmitting, modalService, onSettled]);

  const choose = async choice => {
    setIsSubmitting(true);
    setError('');
    try {
      await onChoose(choice);
      onSettled?.();
      close();
    } catch (choiceError) {
      setError(choiceError?.response?.data?.error || choiceError?.message || 'Could not upgrade this meal.');
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="meal-upgrade-decision"
      role="dialog"
      aria-modal="true"
      aria-labelledby="meal-upgrade-decision-title"
      aria-describedby="meal-upgrade-decision-description"
      aria-busy={isSubmitting}
    >
      <p className="meal-upgrade-eyebrow">Meal upgrade</p>
      <h2 id="meal-upgrade-decision-title">What should happen to your added foods?</h2>
      <p id="meal-upgrade-decision-description">
        The plan changed after this meal was created. Choose whether to keep or delete the foods you added yourself.
      </p>
      <p className="meal-upgrade-common-note">
        Foods already shared with the plan will stay unchanged.
      </p>
      <ul className="meal-upgrade-extra-foods" aria-label="Foods you added">
        {extraFoods.map((food, index) => (
          <li key={food.instance_id || food.food_id || index}>{food.name || 'Unnamed food'}</li>
        ))}
      </ul>
      {error && <p className="meal-upgrade-error" role="alert">{error}</p>}
      <div className="meal-upgrade-actions">
        <button type="button" className="meal-upgrade-keep" autoFocus disabled={isSubmitting} onClick={() => choose('keep')}>
          {isSubmitting ? 'Upgrading…' : 'Keep my foods'}
        </button>
        <button type="button" className="meal-upgrade-delete" disabled={isSubmitting} onClick={() => choose('delete')}>
          Delete my foods
        </button>
        <button
          type="button"
          className="meal-upgrade-cancel"
          disabled={isSubmitting}
          onClick={() => {
            onSettled?.();
            close();
          }}
        >
          Cancel
        </button>
      </div>
    </section>
  );
};

export default MealUpgradeDecisionModal;
